<template>
  <ModalDialog
    ref="dialog"
    title="View Notification"
    :showSubmit="false"
    icon="fa-envelope-open-text"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-if="!loading && !loadingError">
      <div class="communication-header border-bottom pb-2">
        <p class="p-0 m-0 text-muted"> Type: 
          <span>{{formatLookupName(notification.type, NotificationTypeLookup)}}</span>
        </p>
        <p class="p-0 m-0 text-muted">{{notification.createdAt | formatDateCustom('dddd, MMMM Do YYYY [at] h:mm a')}}</p>
        <h4 class="pt-2">{{notification.subject}}</h4>
      </div>
      <div class="communication-body border-bottom py-3">
        <div v-html="notification.message" />
      </div>
      <div class="mt-4" v-if="notification.link && notification.link != ''">
        <LinkButton :href="notification.link" :newTab="true" type="link" sizeClass="btn-sm">View Item</LinkButton>
      </div>
    </FormGroup>
  </ModalDialog>
</template>

<style scoped>

</style>


<script>
import _ from 'lodash'
import moment from 'moment'
import form from '@/mixins/form'
import Utils from '@/utils/utils'

import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import { NotificationTypeLookup } from '@/store/types'

export default {
  name: 'NotificationDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
  },
  props: {
    notificationId: Number
  },
  data() {
    return {
      notification: { },
      loading: false,
      loadingError: '',
    }
  },
  created() {
    this.NotificationTypeLookup = NotificationTypeLookup
  },
  mounted() {
    this.requestData()
  },
  computed: {
  },
  methods: {
    show(options = {}) {
      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {      
    },

    requestData() {
      this.notification = {}
      this.loadingError = ''

      // Get the notification & mark as read
      Promise.all([
        this.$apiService.communicationService.getNotification(this.notificationId),
        this.$apiService.communicationService.updateNotification(this.notificationId, { isRead: true })
      ])
      .then(results => {
        this.notification = results[0].data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
      })
    }
  }
}
</script>